import { useEffect, useState } from "react";
import { Card, Descriptions } from "antd";
import _ from "lodash";

import CardTitle from "components/Common/CardTitle";
import StatusTag from "components/Common/StatusTag";
import useFetch from "hooks/useFetch";
import {
  FIELD_KEYS,
  FIELD_LABELS,
  FIELD_ORDERS,
  INFO_FIELDS,
} from "constants/ItemFields";
import DateTime from "components/Common/DateTime";

// ###### Constants ######

const fieldOrders = _.intersection(FIELD_ORDERS, INFO_FIELDS);

// ###### Functions ######

const renderField = (field, value) => {
  switch (field) {
    case FIELD_KEYS.STATUS:
      return <StatusTag status={value} />;
    case FIELD_KEYS.START_DATE_TIME:
    case FIELD_KEYS.COMPLETED_DATE_TIME:
      return <DateTime utcValue={value} />;
    default:
      return value ?? "-";
  }
};

// ###### Component ######

const ItemInfoCard = ({ itemUuid }) => {
  const {
    loading,
    responseData: itemInfoResponseData,
    doFetch: fetchItemInfo,
  } = useFetch("/items/getItemInfo", "GET", [], false);
  const [intervalId, setIntervalId] = useState();

  const data = itemInfoResponseData.data ?? {};

  useEffect(() => {
    if (!!itemUuid) {
      if (intervalId !== undefined) {
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
      fetchItemInfo({
        item: itemUuid,
      });
    }
  }, [itemUuid]);

  useEffect(()=>{
    if(!!itemUuid && intervalId === undefined && data.length !== 0 && Object.keys(data).length !== 0){
      setIntervalId(
        setInterval(
          ()=>{fetchItemInfo({item: itemUuid});}
          ,100
        )
      )
    }
  },[data])

  useEffect(()=>{
    return() => {
      if(intervalId !== undefined){
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
    };
  },[intervalId])

  return (
    <>
      <Card loading={Object.keys(data).length === 0? loading:false} style={{maxHeight: "25%"}} >
        <CardTitle title="Item Info" />
        <Descriptions column={4} labelStyle={{ fontWeight: "500" }}>
          {fieldOrders.map((fieldKey, index) => (
            <Descriptions.Item key={index} label={FIELD_LABELS[fieldKey]}>
              {renderField(fieldKey, data[fieldKey])}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Card>
    </>
  );
};

export default ItemInfoCard;
